<div class="scrollbar">
  <div class="px-2 mt-4 row" [formGroup]="dynamicForm">
    <div class="row">
      <div class="col-lg-6 col-md-12 col-sm-12 flex-wrapper d-flex align-items-center gap-3 mb-3">
        @if (tab === FormInputs.MODELS) {
          <div class="model-input-field">
            <label class="field-label fw-semibold">{{ 'MODEL' | translate }}<strong class="text-danger">*</strong></label>
            <div class="model-dropdown">
              <select #modelSelect formControlName="selectedModel" class="form-control form-select field-label text-center">
                <option value="" disabled class="form-control">{{ 'SELECT_MODEL' | translate }}</option>
                @for (model of models; track model) {
                  <option [value]="model" class="form-control">
                    {{ model }}
                  </option>
                }
              </select>
            </div>
          </div>
        }
      </div>
    </div>
    @for (field of formFields; track field; let i = $index) {
      @if (field.required) {
        <div class="col-lg-6 col-md-12 col-sm-12 custom-col">
          <div class="col-lg-6 col-md-12 col-sm-12 flex-wrapper d-flex align-items-center gap-3 mb-3">
            <div class="label-required">
              <label class="field-label fw-semibold" for="{{ field?.name }}">
                {{ ('FIELDS.TITLE' | translate) + field.label | translate }}
                <strong class="text-danger">*</strong>
              </label>
            </div>

            <div class="all-input col-md-6 w-25">
              @switch (field?.type) {
                @case ('number') {
                  <input
                    class="form-control w-100"
                    type="number"
                    step="0.01"
                    [formControlName]="field?.name"
                    [value]="field?.value"
                    [required]="field?.required"
                    [min]="convertedMinMax[field.name] ? convertedMinMax[field.name].min : field.min"
                    [max]="convertedMinMax[field.name] ? convertedMinMax[field.name].max : field.max"
                    (blur)="onInputChange($event, field)"
                    [id]="field?.name"
                    [attr.tabindex]="i + 1" />
                }
                @case ('text') {
                  <input
                    type="text"
                    class="form-control w-100"
                    [formControlName]="field?.name"
                    [value]="field?.value"
                    [required]="field?.required"
                    [min]="convertedMinMax[field.name] ? convertedMinMax[field.name].min : field.min"
                    [max]="convertedMinMax[field.name] ? convertedMinMax[field.name].max : field.max"
                    (blur)="onInputChange($event, field)"
                    [id]="field?.name"
                    [attr.tabindex]="i + 1" />
                }
                @case ('dropdown') {
                  <select
                    class="form-control form-select w-100"
                    [formControlName]="field?.name"
                    [required]="field?.required"
                    [id]="field?.name"
                    [attr.tabindex]="i + 1">
                    @for (option of filteredOptions[field.name] || field?.options || []; track option) {
                      <option [value]="option">
                        {{ option }}
                      </option>
                    }
                  </select>
                }
              }
            </div>
            @if (field.units) {
              <div class="unit-dropdown col-md-6 w-50">
                <div>
                  <select
                    class="form-control form-select text-center w-75"
                    (change)="onUnitChange($event, field)"
                    [id]="field?.name + '_units'"
                    [attr.tabindex]="100 + i">
                    @for (unit of field.units; track unit) {
                      <option [value]="unit" [selected]="unit === selectedUnits[field.name]">
                        {{ unit }}
                      </option>
                    }
                  </select>
                </div>
              </div>
            }
            @if (!field.units) {
              <div class="col-md-6">
                <div>
                  <div>{{ field.unitValue }}</div>
                </div>
              </div>
            }
          </div>
          @if (
            dynamicForm.controls[field.name]?.invalid &&
            (dynamicForm.controls[field.name]?.dirty || dynamicForm.controls[field.name]?.touched)
          ) {
            <div class="mb-3 error-message">
              @if (dynamicForm.controls[field.name].errors?.['required']) {
                <span class="text-danger required-error-msg"> {{ 'FIELDS.' + field.label | translate }} {{ 'REQUIRED' | translate }} </span>
              }
            </div>
          }
          @if (field.name === FormInputs.INLET_TEMPERATURE && showWarning) {
            <div class="text-danger pb-3">
              {{ 'WARNINGS.HIGH_AMBIENT_TEMPERATURE' | translate }}
            </div>
          }
        </div>
      }
    }
  </div>
</div>
